import Bugsnag from '@bugsnag/js';

function getClient() {
    return typeof Bugsnag.getClient === 'function' ? Bugsnag.getClient() : null;
}

/**
 * Fixed step label only (no payment data).
 */
export function leavePaymentStep(message) {
    const client = getClient();
    if (!client) {
        return;
    }
    client.leaveBreadcrumb(message, {}, 'state');
}

/**
 * Stripe error fields only — never pass result, payment_intent objects, or client secret.
 */
export function leaveStripeErrorBreadcrumb(message, stripeError) {
    const client = getClient();
    if (!client || !stripeError || typeof stripeError !== 'object') {
        return;
    }
    const meta = {};
    if (stripeError.type != null) {
        meta.type = stripeError.type;
    }
    if (stripeError.code != null) {
        meta.code = stripeError.code;
    }
    if (stripeError.decline_code != null) {
        meta.decline_code = stripeError.decline_code;
    }
    if (stripeError.message != null) {
        meta.message = stripeError.message;
    }
    client.leaveBreadcrumb(message, meta, 'error');
}

/**
 * Axios / same-origin HTTP failure — method, path, status only (no body).
 */
export function leaveHttpErrorBreadcrumb(config, status) {
    const client = getClient();
    if (!client || !config || !config.url) {
        return;
    }
    let path = '';
    try {
        path = new URL(config.url, window.location.origin).pathname;
    } catch (e) {
        return;
    }
    client.leaveBreadcrumb('http:response_error', {
        method: (config.method || 'get').toUpperCase(),
        path,
        status,
    }, 'request');
}

/**
 * No HTTP response (network / CORS / abort).
 */
export function leaveAxiosNetworkErrorBreadcrumb(err) {
    const client = getClient();
    if (!client) {
        return;
    }
    const meta = {};
    if (err && err.code != null) {
        meta.code = err.code;
    }
    if (err && err.message != null) {
        meta.message = err.message;
    }
    client.leaveBreadcrumb('http:network_error', meta, 'request');
}

/**
 * handleCardPayment promise rejection (not a Stripe result object).
 */
export function leavePaymentConfirmRejected(err) {
    const client = getClient();
    if (!client) {
        return;
    }
    const meta = {};
    if (err && err.message != null) {
        meta.message = err.message;
    }
    client.leaveBreadcrumb('payment:stripe_confirm_rejected', meta, 'error');
}
